import {useNotificationStore} from '~/stores/notifications'
import {POS_EVENTS, usePosEventBus} from '~/composables/usePosEventBus'
import {useOrderEvents} from '~/composables/useOrderEvents'
import {useRoute} from 'vue-router'

let isInitialized = false

export function useAppNotifications() {
    const notificationStore = useNotificationStore()
    const {playNotificationSound} = useOrderEvents()
    const route = useRoute()
    const {
        on,
        off,
    } = usePosEventBus()

    const handleItemReady = (payload) => {
        console.log('[AppNotifications] 🍽️ Item ready:', payload)

        const itemName = payload.itemName || `Item ${payload.itemIndex + 1}`
        const orderNum = payload.backendOrderId || payload.backend_order_id || payload.orderId || payload.orderNumber

        notificationStore.addNotification({
            type: 'item_ready',
            title: `Item Ready - Order #${orderNum}`,
            subtitle: `${itemName} is ready`,
            orderId: payload.backendOrderId || payload.backend_order_id || payload.orderId,
            orderNumber: payload.backendOrderId || payload.backend_order_id || payload.orderNumber,
            link: '/orders',
            icon: 'tabler-chef-hat',
            color: 'success',
        })

        notificationStore.showSnackbar({
            message: `Item ready: ${itemName} (Order #${orderNum})`,
            link: '/orders',
            timeout: 8000,
        })

        playNotificationSound()
    }

    const handleOrderReady = (payload) => {
        console.log('[AppNotifications] ✅ Order ready:', payload)

        const orderNum = payload.backendOrderId || payload.backend_order_id || payload.orderNumber || payload.orderId

        notificationStore.addNotification({
            type: 'order_ready',
            title: `Order Ready - #${orderNum}`,
            subtitle: 'All items are ready for pickup',
            orderId: payload.backendOrderId || payload.backend_order_id || payload.orderId,
            orderNumber: payload.backendOrderId || payload.backend_order_id || payload.orderNumber,
            link: '/orders',
            icon: 'tabler-circle-check',
            color: 'success',
        })

        notificationStore.showSnackbar({
            message: `Order #${orderNum} is ready for pickup!`,
            link: '/orders',
            timeout: 8000,
        })

        playNotificationSound()
    }

    const handleCourseFired = (payload) => {
        console.log('[AppNotifications] 🔥 Course fired:', payload)

        const courseName = payload.courseName || 'Course'
        const orderId = payload.orderId

        notificationStore.addNotification({
            type: 'course_fired',
            title: `Course Fired`,
            subtitle: `${courseName} - Kitchen started preparing`,
            orderId: orderId,
            link: '/orders',
            icon: 'mdi mdi-fire',
            color: 'warning',
        })

        notificationStore.showSnackbar({
            message: `🔥 Kitchen fired ${courseName} for Order #${orderId}`,
            link: '/orders',
            timeout: 6000,
        })

        playNotificationSound()
    }

    const handleCourseHeld = (payload) => {
        console.log('[AppNotifications] ⏸️ Course held:', payload)

        const courseName = payload.courseName || 'Course'
        const orderId = payload.orderId

        notificationStore.showSnackbar({
            message: `⏸️ ${courseName} held for Order #${orderId}`,
            link: '/orders',
            timeout: 4000,
        })
    }

    if (!isInitialized) {
        on(POS_EVENTS.POS_ORDER_ITEM_READY, handleItemReady)
        on(POS_EVENTS.POS_ORDER_READY, handleOrderReady)
        on(POS_EVENTS.POS_COURSE_FIRED, handleCourseFired)
        on(POS_EVENTS.POS_COURSE_HELD, handleCourseHeld)
        isInitialized = true
        console.log('[AppNotifications] Initialized - listening for item_ready, order_ready, course_fired, course_held events')
    }

    return {
        notificationStore,
    }
}
